const CustomerDetails =[
    {
        "_id": "60e313c9a6f42c23f0ffd216",
        "index": 0,
        "guid": "91c5dccd-074f-4fa0-9f0c-b3f37fd2ce44",
        "isActive": true,
        "balance": "$3,200.43",
        "picture": "https://picsum.photos/900/600",
        "age": 35,
        "eyeColor": "brown",
        "name": "Ramirez Marsh",
        "gender": "male",
        "company": "EXOSIS",
        "email": "ramirezmarsh@exosis.com",
        "phone": "+1 (963) 505-3267",
        "address": "745 Judge Street, Herald, Utah, 9914",
        "about": "Ex eiusmod et laborum commodo labore ex adipisicing ut elit exercitation mollit qui aliquip Lorem. Labore ad laborum culpa ea magna id laboris deserunt proident. Qui et ut quis sunt proident nulla adipisicing nisi elit esse. Proident anim veniam officia sint voluptate aliqua eu anim nulla commodo ex culpa ipsum dolore.\r\n",
        "registered": "2014-07-13T12:58:03 -03:00",
        "latitude": 84.776852,
        "longitude": -144.818219,
        "tags": [
            "enim",
            "ea",
            "eu",
            "sint",
            "nostrud",
            "Lorem",
            "occaecat"
        ],
        "friends": [
            {
                "id": 0,
                "name": "Wilcox Mann"
            },
            {
                "id": 1,
                "name": "Valeria Anthony"
            },
            {
                "id": 2,
                "name": "Lenora Mason"
            }
        ],
        "greeting": "Hello, Ramirez Marsh! You have 9 unread messages.",
        "favoriteFruit": "banana"
    },
    {
        "_id": "60e313c9a8ed3d3406604fc3",
        "index": 1,
        "guid": "2b653327-978e-4a8d-9535-7c97c716a2e7",
        "isActive": true,
        "balance": "$3,875.32",
        "picture": "https://picsum.photos/900/600",
        "age": 33,
        "eyeColor": "blue",
        "name": "Burch Frank",
        "gender": "male",
        "company": "RETROTEX",
        "email": "burchfrank@retrotex.com",
        "phone": "+1 (815) 483-2592",
        "address": "572 Hanover Place, Marshall, Mississippi, 7533",
        "about": "Aute sit exercitation consectetur aute enim ea labore ea. Proident pariatur occaecat pariatur occaecat ex sint ad excepteur. Consectetur quis incididunt quis dolor sunt veniam deserunt ullamco nisi. Nisi esse magna incididunt reprehenderit labore aliquip qui.\r\n",
        "registered": "2019-12-05T12:16:23 -03:00",
        "latitude": -35.469933,
        "longitude": 72.292237,
        "tags": [
            "dolore",
            "proident",
            "ipsum",
            "culpa",
            "enim",
            "enim",
            "deserunt"
        ],
        "friends": [
            {
                "id": 0,
                "name": "Bessie Serrano"
            },
            {
                "id": 1,
                "name": "Marlene Charles"
            },
            {
                "id": 2,
                "name": "Hardin Austin"
            }
        ],
        "greeting": "Hello, Burch Frank! You have 1 unread messages.",
        "favoriteFruit": "apple"
    },
    {
        "_id": "60e313c9f49d31802833abcd",
        "index": 2,
        "guid": "997be003-08d9-4966-bb96-e7a4662766e9",
        "isActive": false,
        "balance": "$3,945.66",
        "picture": "https://picsum.photos/900/600",
        "age": 38,
        "eyeColor": "green",
        "name": "Dora Burt",
        "gender": "female",
        "company": "MAXIMIND",
        "email": "doraburt@maximind.com",
        "phone": "+1 (904) 590-2978",
        "address": "240 Harrison Place, Allamuchy, Ohio, 4465",
        "about": "Dolore consectetur minim velit velit quis cillum velit ipsum dolore excepteur ad dolore. Enim fugiat enim magna ullamco fugiat culpa eu. Et laboris dolor aliquip ex veniam veniam mollit aute. Esse anim excepteur ipsum velit reprehenderit esse est irure ut eu deserunt. Duis eu velit sit cillum Lorem qui irure elit elit pariatur exercitation ea adipisicing eu.\r\n",
        "registered": "2020-12-23T08:59:37 -03:00",
        "latitude": 87.241262,
        "longitude": 24.195006,
        "tags": [
            "pariatur",
            "non",
            "proident",
            "elit",
            "culpa",
            "veniam",
            "deserunt"
        ],
        "friends": [
            {
                "id": 0,
                "name": "Irene Ortega"
            },
            {
                "id": 1,
                "name": "Dotson Leach"
            },
            {
                "id": 2,
                "name": "Farrell Jacobson"
            }
        ],
        "greeting": "Hello, Dora Burt! You have 8 unread messages.",
        "favoriteFruit": "banana"
    },
    {
        "_id": "60e313c9dbe717c32bfca2b1",
        "index": 3,
        "guid": "9e2b509d-b15e-4f50-ae54-68f6ffd70205",
        "isActive": true,
        "balance": "$2,555.41",
        "picture": "https://picsum.photos/900/600",
        "age": 31,
        "eyeColor": "green",
        "name": "Katheryn Ryan",
        "gender": "female",
        "company": "MAGNEATO",
        "email": "katherynryan@magneato.com",
        "phone": "+1 (924) 455-3903",
        "address": "200 Brooklyn Avenue, Edgar, Minnesota, 3957",
        "about": "Tempor laboris voluptate nulla irure reprehenderit ut incididunt. Reprehenderit ullamco ipsum consectetur amet proident incididunt minim nulla. Nisi labore consequat tempor ipsum aute nulla sit laboris occaecat dolore. Consequat velit do ipsum aliqua ea fugiat et eiusmod voluptate. Incididunt nulla minim duis proident laboris. Dolore ipsum enim velit incididunt id duis excepteur.\r\n",
        "registered": "2018-02-24T08:02:41 -03:00",
        "latitude": 81.601683,
        "longitude": 9.976401,
        "tags": [
            "commodo",
            "ex",
            "exercitation",
            "pariatur",
            "non",
            "exercitation",
            "proident"
        ],
        "friends": [
            {
                "id": 0,
                "name": "Peck Fuller"
            },
            {
                "id": 1,
                "name": "Moore Durham"
            },
            {
                "id": 2,
                "name": "Bender Hoffman"
            }
        ],
        "greeting": "Hello, Katheryn Ryan! You have 8 unread messages.",
        "favoriteFruit": "strawberry"
    },
    {
        "_id": "60e313c9fc6acf7dc17fdf3b",
        "index": 4,
        "guid": "8563e223-8fac-4a32-8370-d4e67aed3ffe",
        "isActive": true,
        "balance": "$2,094.95",
        "picture": "https://picsum.photos/900/600",
        "age": 31,
        "eyeColor": "green",
        "name": "Wilma Mercado",
        "gender": "female",
        "company": "ZAGGLES",
        "email": "wilmamercado@zaggles.com",
        "phone": "+1 (895) 539-3926",
        "address": "782 Howard Alley, Summerset, South Carolina, 2552",
        "about": "Et magna occaecat eu consectetur duis culpa incididunt labore sint reprehenderit cupidatat et. Id do irure qui adipisicing minim anim consectetur voluptate anim minim est labore ad. Amet dolore pariatur duis ullamco Lorem tempor minim consequat magna.\r\n",
        "registered": "2021-06-26T05:22:51 -03:00",
        "latitude": -64.860032,
        "longitude": 169.115431,
        "tags": [
            "amet",
            "eiusmod",
            "tempor",
            "fugiat",
            "et",
            "nostrud",
            "do"
        ],
        "friends": [
            {
                "id": 0,
                "name": "Ophelia Barlow"
            },
            {
                "id": 1,
                "name": "Osborne Woods"
            },
            {
                "id": 2,
                "name": "Shirley Armstrong"
            }
        ],
        "greeting": "Hello, Wilma Mercado! You have 2 unread messages.",
        "favoriteFruit": "banana"
    },
    {
        "_id": "60e313c94f72295bb177b5eb",
        "index": 5,
        "guid": "78ddb483-1324-4eb0-82b1-713da4dacc3e",
        "isActive": false,
        "balance": "$3,440.09",
        "picture": "https://picsum.photos/900/600",
        "age": 35,
        "eyeColor": "green",
        "name": "Carrillo Pennington",
        "gender": "male",
        "company": "TALAE",
        "email": "carrillopennington@talae.com",
        "phone": "+1 (896) 551-3954",
        "address": "595 Olive Street, Draper, North Carolina, 7763",
        "about": "Quis velit nisi labore ad officia nulla pariatur. Dolore sit excepteur aute quis nostrud tempor proident. Do exercitation deserunt et aliquip adipisicing sint officia. Exercitation consectetur do aliqua irure labore laboris eiusmod tempor sit non do.\r\n",
        "registered": "2014-03-06T05:44:16 -02:00",
        "latitude": -73.093842,
        "longitude": -68.312375,
        "tags": [
            "tempor",
            "magna",
            "veniam",
            "tempor",
            "esse",
            "id",
            "minim"
        ],
        "friends": [
            {
                "id": 0,
                "name": "Lorena Mcguire"
            },
            {
                "id": 1,
                "name": "Alana Chen"
            },
            {
                "id": 2,
                "name": "Melba Guerra"
            }
        ],
        "greeting": "Hello, Carrillo Pennington! You have 1 unread messages.",
        "favoriteFruit": "banana"
    },
    {
        "_id": "60e313c9097f602dc5e26536",
        "index": 6,
        "guid": "f777a4a4-0e41-4483-9d5d-59c202d789e6",
        "isActive": true,
        "balance": "$3,379.80",
        "picture": "https://picsum.photos/900/600",
        "age": 25,
        "eyeColor": "blue",
        "name": "Liz Gonzales",
        "gender": "female",
        "company": "QUILM",
        "email": "lizgonzales@quilm.com",
        "phone": "+1 (968) 520-3353",
        "address": "897 Livonia Avenue, Silkworth, New Mexico, 7074",
        "about": "Consequat occaecat aliquip dolore ipsum. Proident mollit aliqua Lorem Lorem aliqua non fugiat laborum amet. Id nisi anim magna culpa consectetur. Anim ex ad aliquip fugiat nisi anim id laboris ipsum. Proident enim amet aliquip anim sint occaecat. Ut ex deserunt cillum labore.\r\n",
        "registered": "2014-09-28T08:48:18 -03:00",
        "latitude": -59.044463,
        "longitude": -45.849535,
        "tags": [
            "consequat",
            "cupidatat",
            "mollit",
            "consectetur",
            "adipisicing",
            "ullamco",
            "cillum"
        ],
        "friends": [
            {
                "id": 0,
                "name": "Adrian Middleton"
            },
            {
                "id": 1,
                "name": "Kelly Hayden"
            },
            {
                "id": 2,
                "name": "Rachelle Summers"
            }
        ],
        "greeting": "Hello, Liz Gonzales! You have 7 unread messages.",
        "favoriteFruit": "apple"
    }
]

export default CustomerDetails;